import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppConfig, APP_CONFIG } from 'src/app.config';
import { UserService } from './user.service';
import { getAuthToken } from '../auth.interceptor';

// inject the project
@Injectable({
    providedIn: 'root',
})
export class getDocumentService {
    requestData: any = {
        userId: '',
        Producers: [] as string[],
    };
    url = this.config.policyOrchestratorUrl;
    private get apiHeaders() {
        return new HttpHeaders({ 'x-api-key': this.config.policyOrchestratorApiKey });
    }
    selectedType: string;
    public type = new BehaviorSubject<any>(null);

    constructor(
        private http: HttpClient,
        private userService: UserService,
        @Inject(APP_CONFIG) private config: AppConfig
    ) {}

    getAllDocuments(value: any, isThirdParty: boolean = false, sessionId?: string): Observable<any> {
        this.resetRequestBody(isThirdParty, sessionId);
        this.selectedType = this.type.getValue();
        
        if (this.selectedType === 'Name insured') {
            this.requestData.fullName = value;
        } else if (this.selectedType === 'Risk address') {
            this.requestData.riskAddress = value;
        } else {
            this.requestData.policyNo = value;
        }
        
        return this.http.post(this.url, this.requestData, { headers: this.apiHeaders });
    }

    private getCurrentUserProducerCode(): string {
        const user = this.userService.getUser();
        if (user && user.Producer_Code) {
            return user.Producer_Code;
        }

        return '';
    }

    private getCurrentUserId(): string {
        const user = this.userService.getUser();
        return (user && (user.preferred_username || user.email || user.sub)) || '';
    }

    resetRequestBody(isThirdParty: boolean = false, sessionId?: string) {
        if (isThirdParty) {
            this.requestData = {
                requestType: 'searchPoliciesForTP',
            };
            if (sessionId) {
                this.requestData.sessionId = sessionId;
            }
        } else {
            this.requestData = {
                token: `Bearer ${getAuthToken()}`,
                requestType: 'searchPolicies',
            };
        }
    }
}
